import { get } from "../../lib/lodash";
import { getAvg } from "../../utils";

export const filterAvgItems = (items, returnValue = true) => {
  return items.filter((item) => !!item && typeof get(item, 'value') !== 'string' && get(item, 'value') !== -1 && ![undefined, null, NaN].includes(get(item, 'value'))).map((v) => (returnValue ? get(v, 'value') : v));
};

export const avgItems = (items = []) => {
  return getAvg(filterAvgItems(items));
};

export const sumCount = (items) => {
  return (items || []).reduce((acc, c) => acc + get(c, 'count', 0), 0);
};